import Vue from "vue";
import { MutationTree } from "vuex";
import { DeskState } from "./types";
import { UnlistenerFunction } from "../friends/types";
import firebase from "firebase/app";
import { Desk, ItemRef, GameInfo, HandDocument } from "@dokogd/shared";
import { clamp } from "lodash";

const SET_LISTENER_INVITE = "SET_LISTENER_INVITE";
const SET_INVITES = "SET_INVITES";
const SET_LISTENER_DESK = "SET_LISTENER_DESK";
const SET_DESK = "SET_DESK";
const SET_LISTENER_GAME = "SET_LISTENER_GAME";
const PATCH_HAND = "PATCH_HAND";
const UPDATE_GAME_INFO = "UPDATE_GAME_INFO";
const SET_LOADING_STATE = "SET_LOADING_STATE";
const TOGGLE_DISPLAY_GAME_MODE = "TOGGLE_DISPLAY_GAME_MODE";
const SWITCH_GAME = "SWITCH_GAME";
const SELECT_GAME = "SELECT_GAME";
const n = {
  SET_LISTENER_INVITE,
  SET_INVITES,
  SET_LISTENER_DESK,
  SET_DESK,
  SET_LISTENER_GAME,
  PATCH_HAND,
  UPDATE_GAME_INFO,
  SET_LOADING_STATE,
  TOGGLE_DISPLAY_GAME_MODE,
  SWITCH_GAME,
  SELECT_GAME,
};

export const mutations: MutationTree<DeskState> = {
  [n.SET_LISTENER_INVITE](state, payload: UnlistenerFunction | null) {
    const prevUnlistener = state.invitesUnlistener;
    state.invites = [];
    state.invitesUnlistener = payload;

    if (prevUnlistener !== null) {
      prevUnlistener();
    }
  },
  [n.SET_INVITES](state, payload: ItemRef[]) {
    console.log(n.SET_INVITES, payload);
    state.invites = payload;
  },
  [n.SET_LISTENER_DESK](state, payload: UnlistenerFunction | null) {
    const prevUnlistener = state.deskUnlistener;
    state.desk = null;
    state.deskUnlistener = payload;

    if (prevUnlistener !== null) {
      prevUnlistener();
    }
  },
  [n.SET_DESK](
    state,
    payload: { data: Desk<firebase.firestore.Timestamp>; id: string } | null
  ) {
    console.log(n.SET_DESK, payload);
    if (payload) {
      const gameCount = payload.data.games.length;
      state.watchGame = gameCount <= 0 ? 0 : gameCount - 1;
      state.id = payload.id;
      state.desk = payload.data;
    } else {
      state.id = null;
      state.desk = null;
    }
  },
  [n.SET_LISTENER_GAME](state, payload: UnlistenerFunction | null) {
    const prevUnlistener = state.invitesUnlistener;
    state.gameInfo = null;
    state.hands = [10, 10, 10, 10];
    state.gameUnlistener = payload;

    if (prevUnlistener !== null) {
      prevUnlistener();
    }
  },
  [n.PATCH_HAND](
    state,
    payload: {
      idx: number;
      data: HandDocument | 10;
    }
  ) {
    console.log(n.PATCH_HAND, payload);

    Vue.set(state.hands, payload.idx, payload.data);
  },
  [n.UPDATE_GAME_INFO](state, gameInfo: GameInfo | null) {
    console.log(n.UPDATE_GAME_INFO, gameInfo, state.gameInfo?.no, gameInfo?.no);

    const oldState = gameInfo?.gameState ?? "";
    const isGameStart =
      gameInfo?.tricks.length === 0 &&
      gameInfo?.currentTrick.length === 0 &&
      ["findPartnerTrump", "findPartnerNonTrump", "normalTricks"].includes(
        oldState
      );

    state.displayGameMode = isGameStart;
    console.log(
      "UPDATE",
      state.displayGameMode,
      state.gameInfo?.gameState,
      gameInfo?.gameState
    );
    state.gameInfo = gameInfo;
  },
  [n.SET_LOADING_STATE](state, loadingState: boolean) {
    state.loading = loadingState;
  },
  [n.TOGGLE_DISPLAY_GAME_MODE](state) {
    state.displayGameMode = !state.displayGameMode;
  },
  [n.SWITCH_GAME](state, payload: number) {
    const gameCount = state.desk?.games.length ?? 0;
    if (gameCount !== 0) {
      state.watchGame = (state.watchGame + payload + gameCount) % gameCount;
    } else {
      state.watchGame = 0;
    }
  },
  [n.SELECT_GAME](state, payload: number) {
    const gameCount = state.desk?.games.length ?? 0;
    state.watchGame = clamp(payload, 0, gameCount - 1);
  },
};

export const mutationNames = n;
